import { render, staticRenderFns } from "./membresia.vue?vue&type=template&id=4ec37a25&scoped=true&"
import script from "./membresia.vue?vue&type=script&lang=js&"
export * from "./membresia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec37a25",
  null
  
)

export default component.exports